<div class="bh-block">
    <h2 class="bh-block-title">We understand your worry!</h2>
    <p class="bh-block-subtitle">That is why we are removing all barriers, and bringing the best curriculum and teachers together.</p>
    <div class="bh-block-cards">
        <div class="bh-worry-card">
            <img ngSrc="assets/images/icons/icon_ic.svg" alt="" width="100" height="100">
            <p>3 Day Free Trial</p>
            <span>Sign up, worry-free! There is absolutely no obligation. You can cancel your trial at anytime.</span>
        </div>
        <div class="bh-worry-card">
            <img ngSrc="assets/images/icons/icon_ic2.svg" alt="" width="100" height="100">
            <p>Award-Winning</p>
            <span>ArgoPrep was awarded 15 educational awards just in the past 12 months!</span>
        </div>
        <div class="bh-worry-card">
            <img ngSrc="assets/images/icons/icon_ic3.svg" alt="" width="100" height="100">
            <p>Licensed Teachers</p>
            <span>Our materials, lessons, and quizzes are created by state-certified teachers.</span>
        </div>
    </div>
</div>

